import { useState } from "react";
import { useNavigate } from "react-router-dom";

const Signup = () => {
    const [name, setname] = useState('');
    const [email, setmail] = useState('');
    const [pass, setpass] = useState('');
    const [cpass, setcpass] = useState('');
    const nav = useNavigate('');

    const regis = async (e) => {
        e.preventDefault();
        if (cpass != pass) {
            alert("Passwords do not match");
        }
        else {
            const data = { name, email, pass };
            let resp = await fetch("http://localhost:9000/api/addata",
                {
                    method: "post",
                    body: JSON.stringify(data),
                    headers: { 'Content-type': "application/json" }
                })
            if (resp.ok) { 
                let res = await resp.json();
                if(res.statuscode===1){
                    alert("Success")
                    nav('/login');
                }else{
                    alert("fail");
                }
            }
        }
    }
    return (
        <>
        <br/> <br/>
            <div className="box mt-2">
                <div className="formt mt-1">
                    <form onSubmit={regis}>
                    <ul>
                        <li> <input type="text" onChange={(e) => setname(e.target.value)} placeholder="Your Name" /> </li> <br />
                        <li> <input type="text" onChange={(e) => setmail(e.target.value)} placeholder="Email" /> </li> <br />
                        <li> <input type="password" onChange={(e) => setpass(e.target.value)} placeholder="Password" /> </li> <br />
                        <li> <input type="password" onChange={(e) => setcpass(e.target.value)} placeholder="confirm password" /> </li> <br />
                        <li> <button type="submit"> Register </button> </li>
                    </ul>
                    </form>
                </div>
            </div>
        </>
    )
}

export default Signup;